import { inject, NewInstance, BindingEngine } from 'aurelia-framework';
import { StandardModifierService } from 'pages/standard-setup/standard-modifiers/service';
import { MaterialService } from 'pages/system-fields/materials/service';
import { PartService } from 'pages/quote-setup/parts/service';
import { ProcessService } from 'pages/standard-setup/processes/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), EventAggregator, DialogService, StandardModifierService, MaterialService, PartService, ProcessService, BindingEngine)
export class StandardModifierEditor {
    constructor(controller, validationController, ea, dialogService, standardModifierService, materialService, partService, processService, bindingEngine) {
        this.controller = controller;
        this.ea = ea;
        this.dialogService = dialogService;
        this.materialService = materialService;
        this.partService = partService;
        this.processService = processService;
        this.standardModifierService = standardModifierService;
        this.standardModifier = {
          identifier: 'MATERIAL',
          processId: null,
          workCenter: 'STAMPING',
          operation: 'MULTIPLICATION'
        };

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('identifier').required()
            .ensure('identifierId').required()
            .ensure('workCenter').required()
            .ensure('processId').required()
            .ensure('multiplier').required()
            .rules;

        bindingEngine.propertyObserver(this.standardModifier, 'identifier')
            .subscribe(async (newValue, oldValue) => {
                if (newValue != null) {
                  this.standardModifier.identifierId = null;
                }
            });
    }

    async activate(model) {
        if (model?.id != null) {
            this.standardModifier = await this.standardModifierService.getById(model.id);
        }
        else {
          if (model) {
            this.standardModifier = model;
          }
        }
    }

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.standardModifier.id) {
                    await this.standardModifierService.update(this.standardModifier);
                    toastr.success('Standard modifier was updated!');
                    this.ea.publish('standard-modifiers:updated', this.standardModifier);
                    this.controller.ok(this.standardModifier);
                } else {
                    let id = await this.standardModifierService.create(this.standardModifier);
                    this.standardModifier.id = id;
                    toastr.success('New standard modifier was created!');
                    this.ea.publish('standard-modifiers:updated', this.standardModifier);
                    this.controller.ok(this.standardModifier);
                }
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
